module.exports = __webpack_public_path__ + "static/media/whatsapp.82c0b865.png";